import type {Component} from 'vue'

import CodeBlock from './code-block.vue'
import Media from './media.vue'
import NewsletterForm from './newsletter-form.vue'
import RawHtml from './raw-html.vue'

const blocks: Record<string, Component> = {
  Code: CodeBlock,
  NewsletterForm: NewsletterForm,
  RawHtml: RawHtml,
}

export function getBlockComponent(blockType: string): Component | undefined {
  return blocks[blockType]
}

export {Media}
